import React from "react";
import { Button, Grid, withStyles } from "@material-ui/core";
import styles from "../styles";
import { PICKUP_OPTIMYZER_STEP } from "../constants";

const ActionButtons = ({
  classes,
  activeStep,
  totalSteps,
  onBackToStep1,
  onClose,
  buttonContent,
}) => {
  const showBackToStep1 = activeStep === PICKUP_OPTIMYZER_STEP.REVIEW_OPTIMIZED_SOLUTION;
  return (
    <Grid container spacing={24}>
      <Grid item xs={4}></Grid>
      <Grid item xs={8} classes={{ item: classes.actionButton }}>
        {activeStep === totalSteps - 1 ? null : (
          <Button
            variant="outlined"
            color="primary"
            onClick={onClose}
            className={classes.button}
            id="closeButton"
          >
            Cancel
          </Button>
        )}
        {showBackToStep1 ? (
          <Button
            onClick={onBackToStep1}
            variant="contained"
            color="primary"
            className={classes.button}
          >
            Back to Step 1
          </Button>
        ) : null}

        {buttonContent}
      </Grid>
    </Grid>
  );
};
export default withStyles(styles)(ActionButtons);
